import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64a302ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"background":"rgba(239, 243, 247, 1)","min-height":"100vh"} }
const _hoisted_2 = {
  class: "p-15px",
  style: {"background-color":"#fff","margin-top":"-6px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-14px font-bold" }, "防伪查询", -1))
const _hoisted_4 = {
  key: 0,
  style: {"height":"120px"}
}
const _hoisted_5 = {
  key: 1,
  style: {"height":"120px"}
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-18px font-bold leading-30px",
  style: {"color":"rgba(128, 201, 196, 1)"}
}, " 您所查询的是由东方沉香集团生产的系列产品，是正牌产品的标识 ", -1))
const _hoisted_8 = {
  class: "text-13px font-400",
  style: {"color":"rgba(0, 0, 0, 0.45)"}
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 本次为第")
const _hoisted_10 = { style: {"color":"rgba(169, 20, 50, 1)"} }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("次查询 ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-right font-400 text-16px mt-24px",
  style: {"color":"rgba(128, 201, 196, 1)"}
}, " 众香之首药中之王！ ", -1))
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-18px font-bold leading-30px",
  style: {"color":"rgba(212, 48, 48, 1)"}
}, " 防伪码非法，请确认后重新查询 ", -1))
const _hoisted_15 = [
  _hoisted_14
]

import { verifyCode as verifyCode2 } from '@/api/domain'
import 'amfe-flexible'
import { Image as VanImage, Divider, Field, Button, Toast } from 'vant'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import VerifyCode from 'vue-verify-code'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const image = require('./assets/top-bg.png')
const isReal = ref(false)
const status = ref(false)
const code = ref('')
const codeRef = ref()
const codeValue = ref()
const vCodeValue = ref()
const searchCount = ref(0)
const router = useRouter()
const handleChange = (newCode) => {
  console.log(newCode)

  code.value = newCode
}

const getCode = (code1) => {
  console.log('验证码', code1)
  code.value = code1
}

const refresh = () => {
  console.log(code.value)
  codeRef.value.display()
  // this.$refs.verifyCode.refresh()
}

const search = () => {
  if (!status.value) {
    if (!codeValue.value) {
      Toast('请先输入防伪码')
      return
    }
    if (vCodeValue.value != code.value) {
      console.log(vCodeValue.value, code.value)

      Toast('验证码错误')
      codeRef.value.display()
      return
    } else {
      status.value = true
      verifyCode2({ code: codeValue.value }).then((res) => {
        console.log(res)
        if (!res.data) {
          isReal.value = false
        } else {
          isReal.value = true
          searchCount.value = res.data.currentVerifyTime
        }
      })
    }
  } else {
    status.value = !status.value
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(VanImage), {
      src: _unref(image),
      height: "368rpx",
      width: "100%"
    }, null, 8, ["src"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createVNode(_unref(Divider)),
        (!status.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(Field), {
                modelValue: codeValue.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((codeValue).value = $event)),
                label: "防伪码:",
                placeholder: "请输入防伪码",
                labelWidth: "55px"
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(Field), {
                modelValue: vCodeValue.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((vCodeValue).value = $event)),
                label: "验证码:",
                placeholder: "请输入验证码",
                labelWidth: "55px"
              }, {
                button: _withCtx(() => [
                  _createVNode(_unref(VerifyCode), {
                    strict: false,
                    style: {"margin-top":"10px"},
                    ref_key: "codeRef",
                    ref: codeRef,
                    onGetCode: getCode,
                    codeLength: "4",
                    width: "80",
                    height: "22",
                    fontSize: "18",
                    charPreset: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
                    lineCount: "0",
                    backgroundColor: "#f1f1f1",
                    textColor: "#333",
                    lineColor: "#ccc",
                    onChange: handleChange,
                    onClick: refresh
                  }, null, 512)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (isReal.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("p", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("span", _hoisted_10, _toDisplayString(searchCount.value), 1),
                      _hoisted_11
                    ]),
                    _hoisted_12
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
            ])),
        _createVNode(_unref(Button), {
          block: "",
          type: "primary",
          color: "rgba(128, 201, 196, 1)",
          style: {"font-size":"18px","width":"282px","height":"36px","margin":"0 auto","margin-top":"19px"},
          onClick: search
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(!status.value ? '查询' : '重新查询'), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})